/**
 * The "make and model may vary" line a quote carries when it sells a whole
 * assembly (server: `services/assemblySubstitutionNote.ts`, setting
 * `quotes.assembly_substitution_note`). It is a $0 line only so it travels
 * with the quote; every customer screen shows it as words, never "$0.00".
 */
export const ASSEMBLY_SUBSTITUTION_NOTE =
    "Make and model may vary based on availability; any substitute meets the same approval and standards.";

export function isAssemblyNote(line: { description?: string | null; line_total?: string | number | null }): boolean {
    if ((line.description ?? "").trim() !== ASSEMBLY_SUBSTITUTION_NOTE) return false;
    return line.line_total == null || Number(line.line_total) === 0;
}
